export default __webpack_public_path__ + "static/media/a008-A.66dcd3b2.svg";